import styled from "styled-components";
import theme from "themes/simple-theme";

export { default as Tab } from "./tab";

const Tabs = styled.ul`
  background: ${theme.color.tertiary};
  list-style-type: none;
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  margin: 0px;
  padding: 0px;
  z-index: 1;
`;

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/Tabs/index.tsx